import { Badge } from "@volca/ui/components/ui/badge";
import { BadgeGroup } from "@volca/ui/components/ui/badge-group";
import { LogoIcon } from "@volca/ui/components/ui/logo";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import type { IUser } from "@/core/auth/auth";
import { roleLabel } from "@/user/constants";

export const ImpersonationIdentity = ({ user }: { user: IUser }) => {
  const name =
    [user.first_name, user.last_name].filter(Boolean).join(" ") || user.email;
  const role = user.role && roleLabel(user.role);
  const details = [
    role && `Role: ${role}`,
    user.parentable_name && `Company: ${user.parentable_name}`,
  ]
    .filter(Boolean)
    .join("\n");
  return (
    <Stack
      direction="row"
      align="center"
      gap={3}
      className="min-w-0 max-md:flex-1 max-md:flex-col max-md:items-stretch max-md:gap-0.5"
      title={[name, user.email, details].filter(Boolean).join("\n")}
    >
      <Stack direction="row" align="baseline" gap={1.5} className="min-w-0">
        <Text
          render={<span />}
          variant="body"
          weight="normal"
          className="shrink-0"
        >
          Acting as
        </Text>
        <Text
          render={<span />}
          variant="body"
          weight="semibold"
          truncate
          className="min-w-0"
        >
          {name}
        </Text>
      </Stack>
      {details && (
        <BadgeGroup aria-label="Acting role and company">
          {role && (
            <Badge
              variant="secondary"
              color="neutral"
              size="sm"
              aria-label={`Role: ${role}`}
            >
              {role}
            </Badge>
          )}
          {user.parentable_name && (
            <Badge
              variant="outline"
              color="neutral"
              size="sm"
              className="min-w-0 shrink"
              aria-label={`Company: ${user.parentable_name}`}
            >
              <span className="inline-flex shrink-0" aria-hidden>
                <LogoIcon width={14} height={11} />
              </span>
              <span className="min-w-0 truncate font-normal">
                {user.parentable_name}
              </span>
            </Badge>
          )}
        </BadgeGroup>
      )}
    </Stack>
  );
};
